var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconServices = function SvgIconServices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.95 4c-3.327 0-6.033 2.68-6.033 5.975 0 3.296 2.706 5.975 6.033 5.975 3.327 0 6.133-2.68 6.133-5.975C23.083 6.68 20.277 4 16.95 4ZM16.95 18.938c-5.31 0-9.717 4.002-10.45 9.062h21c-.733-5.06-5.24-9.062-10.55-9.062Z",
    fill: "#C1CED9"
  })));
};

export default SvgIconServices;